import React from 'react';
import { Skeleton } from 'primereact/skeleton';

const TrustHorizonPlaceholder = () => {
  return (
    <div className="card-bg mt-3 mb-3 p-3">
      <div className="row mb-3">
        <div className="col-sm-12 d-flex align-items-center mb-2">
          <div className="text-bold black-800 me-2">LAWFT HORIZON</div>
          <i className="pi pi-info-circle me-2 pointer text-muted"></i>
        </div>
        <div className="col-sm-12 mb-3">
          <Skeleton width="30%" height="40px" className="mb-2" borderRadius="6px" />
          <hr className="my-2" />
        </div>
        <div className="col-sm-12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Skeleton width="50%" height="20px" borderRadius="4px" />
            <Skeleton width="25%" height="20px" borderRadius="4px" />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <Skeleton width="60%" height="20px" borderRadius="4px" />
            <Skeleton width="25%" height="20px" borderRadius="4px" />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <Skeleton width="70%" height="20px" borderRadius="4px" />
            <Skeleton width="25%" height="20px" borderRadius="4px" />
          </div>

          <hr className="my-2" />

          <div className="d-flex justify-content-between align-items-center mb-2">
            <Skeleton width="40%" height="20px" borderRadius="4px" />
            <Skeleton width="25%" height="20px" borderRadius="4px" />
          </div>

          <div className="mt-2">
            <Skeleton width="20%" height="24px" borderRadius="4px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustHorizonPlaceholder;
